import React, { FC } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { variant } from 'styled-system';

import { Glyph } from '../../iconography/Glyph';
import sx from '../../internal/styles/sx';
import { BaseFlex } from '../../layouts/Flex/Flex';
import { CheckboxIconProps } from './types';

export const StyledIcon = styled(BaseFlex, { shouldForwardProp })(
  css({
    position: 'relative',
    backgroundColor: 'checkbox.default.bgColor',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'checkbox',
    borderColor: 'checkbox.default.borderColor',
    borderRadius: 'small',
    boxSizing: 'border-box',
    height: 'checkbox.height',
    width: 'checkbox.minWidth',
    color: 'checkbox.default.iconColor',
    flexShrink: 0,
  }),
  variant({
    prop: 'checked',
    variants: {
      true: {
        backgroundColor: 'checkbox.checked.bgColor',
        borderColor: 'checkbox.checked.borderColor',
        color: 'checkbox.checked.iconColor',
      },
    },
  }),
  variant({
    prop: 'hasError',
    variants: {
      true: {
        backgroundColor: 'checkbox.error.bgColor',
        borderColor: 'checkbox.error.borderColor',
        color: 'checkbox.error.iconColor',
      },
    },
  }),
  variant({
    prop: 'disabled',
    variants: {
      true: {
        backgroundColor: 'checkbox.disabled.bgColor',
        borderColor: 'checkbox.disabled.borderColor',
        color: 'checkbox.disabled.iconColor',
        opacity: 'checkbox.disabled',
        cursor: 'not-allowed',
      },
    },
  }),
  variant({
    prop: 'type',
    variants: {
      circle: {
        borderRadius: 'full',
      },
    },
  }),
  sx
);

const CheckboxIcon: FC<CheckboxIconProps> = (props) => (
  <StyledIcon {...props}>
    {props?.checked && <Glyph category="UIActions" name="Check" size="small" />}
  </StyledIcon>
);

export default CheckboxIcon;
